import React from 'react';
import { X } from 'lucide-react';
import { QRCodeSVG } from 'qrcode.react';
import appStoreBadge from '../App_Store_Badge.svg';
import googleBadge from '../Google_Badge.svg';
import {
  ModalOverlay,
  ModalContent,
  CloseButton,
  ModalTitle,
  ModalText,
  QRGrid,
  QRColumn,
  QRContainer,
  StoreLabel,
} from '../styles/modal';

function QRModal({ isOpen, onClose }) {
  const APP_STORE_LINK = 'https://apps.apple.com/gb/app/playfair/id6754043983';
  const PLAY_STORE_LINK =
    'https://play.google.com/store/apps/details?id=com.davebuck98.footyfines&hl=en_GB';

  if (!isOpen) return null;

  return (
    <ModalOverlay
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={onClose}
    >
      <ModalContent
        initial={{ scale: 0.9, y: 20 }}
        animate={{ scale: 1, y: 0 }}
        exit={{ scale: 0.9, y: 20 }}
        onClick={(e) => e.stopPropagation()}
      >
        <CloseButton onClick={onClose}>
          <X size={24} />
        </CloseButton>

        <ModalTitle>Download Playfair</ModalTitle>
        <ModalText>
          Scan the QR code with your phone camera to download the inDrive app
        </ModalText>

        <QRGrid>
          <QRColumn>
            <StoreLabel>
              <img src={appStoreBadge} alt="iOS" />
              <span>iOS</span>
            </StoreLabel>
            <QRContainer>
              <QRCodeSVG
                value={APP_STORE_LINK}
                size={160}
                bgColor="#ffffff"
                fgColor="#000000"
                level="H"
                includeMargin={false}
              />
            </QRContainer>
          </QRColumn>

          <QRColumn>
            <StoreLabel>
              <img src={googleBadge} alt="Android" />
              <span>Android</span>
            </StoreLabel>
            <QRContainer>
              <QRCodeSVG
                value={PLAY_STORE_LINK}
                size={160}
                bgColor="#ffffff"
                fgColor="#000000"
                level="H"
                includeMargin={false}
              />
            </QRContainer>
          </QRColumn>
        </QRGrid>
      </ModalContent>
    </ModalOverlay>
  );
}

export default QRModal;
